import Lottery from './lottery';
export default Lottery;
